import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    active: Boolean,
    message: String
  }

  connect() {
    if (!this.activeValue) return

    this.preventSubmission = this.preventSubmission.bind(this)
    this.element.addEventListener("submit", this.preventSubmission, true)
    this.disableMutationForms()
    this.observeDisabledControls()
  }

  disconnect() {
    if (!this.activeValue) return

    this.element.removeEventListener("submit", this.preventSubmission, true)
    this.observer?.disconnect()
    this.notes?.forEach((note) => note.remove())

    this.controls?.forEach((control) => {
      if (control.dataset.readOnlyWorkspaceWasDisabled === "false") {
        control.disabled = false
      }
      delete control.dataset.readOnlyWorkspaceWasDisabled
      delete control.dataset.readOnlyWorkspaceForced
      control.removeAttribute("aria-disabled")
      if (control.title === this.messageValue) control.removeAttribute("title")
    })
  }

  preventSubmission(event) {
    if (this.formAllowed(event.target)) return

    event.preventDefault()
    event.stopImmediatePropagation()
  }

  disableMutationForms() {
    this.controls = []
    this.notes = []

    this.element.querySelectorAll("form").forEach((form) => {
      if (this.formAllowed(form)) return

      form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((control) => {
        control.dataset.readOnlyWorkspaceWasDisabled = control.disabled.toString()
        control.dataset.readOnlyWorkspaceForced = "true"
        control.disabled = true
        control.setAttribute("aria-disabled", "true")
        control.title = this.messageValue
        this.controls.push(control)

        const note = this.element.ownerDocument.createElement("span")
        note.className = "read-only-control-message"
        note.textContent = this.messageValue
        control.insertAdjacentElement("afterend", note)
        this.notes.push(note)
      })
    })
  }

  observeDisabledControls() {
    this.observer = new window.MutationObserver((mutations) => {
      mutations.forEach(({ target }) => {
        if (target.dataset.readOnlyWorkspaceForced === "true" && !target.disabled) {
          target.disabled = true
        }
      })
    })

    this.observer.observe(this.element, {
      subtree: true,
      attributes: true,
      attributeFilter: ["disabled"]
    })
  }

  formAllowed(form) {
    if (form.dataset.readOnlyAllowed === "true") return true

    const override = form.querySelector('input[name="_method"]')?.value.toLowerCase()
    const method = override || form.method.toLowerCase()
    return method === "get"
  }
}
